import PageTitleBar from "../components/PageTitleBar";

type PlaceholderPageProps = {
  title: string;
  subtitle?: string;
};

export default function PlaceholderPage({
  title,
  subtitle = "This section is not available yet.",
}: PlaceholderPageProps) {
  return (
    <div className="h-full w-full p-6">
      <PageTitleBar title={title} subtitle={subtitle} />

      <div className="mt-8 rounded-xl border border-dashed border-cyan-200 bg-white p-6 shadow-sm dark:border-cyan-900/50 dark:bg-gray-800">
        <p className="text-sm text-gray-700 dark:text-gray-300">
          Placeholder page for {title.toLowerCase()}. Content will be added in a future
          update.
        </p>
      </div>
    </div>
  );
}
